import Vue from 'vue'
import { VTooltip } from 'v-tooltip'

VTooltip.options.defaultTrigger = 'click hover'
Vue.directive('tooltip', VTooltip)
